import Card, { Body, DeepLink, ObjectLink, Subtitle } from '../CardComponents';

import { ProspectStatusChip } from '~/containers/screening/prospects/components/ProspectStatusChip/ProspectStatusChip';

export default function ScreeningProspect({ result }) {
	const { highlights, xray, data } = result;
	const { prospectID, name, email, status, leadSource } = data;

	const path = `/screening/prospects/${prospectID}`;

	return (
		<Card.Parent path={path} cardType="Prospect">
			<Card.Content>
				<Card.Header title={name} highlight={highlights?.name?.[0]?.[0]} cardType="Prospect" />

				<Body>
					<Subtitle.Parent>{email && <Subtitle.Item value={email} highlight={highlights?.email?.[0]?.[0]} />}</Subtitle.Parent>

					<DeepLink.Parent>
						<DeepLink.Xrays xrays={xray} highlights={highlights} limit={5} />
					</DeepLink.Parent>

					<ObjectLink.Parent columns={2}>
						<ObjectLink.Title value="Status" />
						<ObjectLink.Title value="Source" />
						<ObjectLink.Item
							value={
								status ? (
									<div className="mt-150">
										<ProspectStatusChip status={status} />
									</div>
								) : (
									'--'
								)
							}
						/>
						<ObjectLink.Item value={leadSource || '--'} />
					</ObjectLink.Parent>
				</Body>
			</Card.Content>
		</Card.Parent>
	);
}
